import { gql } from '@apollo/client';

export const ADD_GROUP_ATTENDEES_TO_SESSION = gql`
  mutation addGroupAttendeesToSession($input: AddGroupAttendeesToSessionInput!) {
    session: addGroupAttendeesToSession(input: $input) {
      id
    }
  }
`;
